import { StoreAction } from "@kuchenmeister/modules-react-effectstore";
import { IResumeRequest } from "../api";
import { sessionStore } from "../utils";

// logoff story
export function* logoffStory(action: StoreAction<{ session: IResumeRequest }>) {
    sessionStore.remove();
}
